import type { ReactNode } from 'react'

/**
 * PC：外层居中、最大宽度 430px，模拟手机视口（与 Next `app/layout` 一致）。
 * `transform-gpu`：让 `position: fixed` 的子层（抽屉、底部导航、弹层）相对于本列定位，而不是整屏。
 *
 * 背景：`bg-home-ambient` 放在不滚动的外层，mint/lime 环境光在视口内保持固定，
 * 内部页面默认透明即可继承；如果某个页面需要自己的背景（如登录页），
 * 只需在页面根节点设置不透明背景覆盖即可。
 *
 * 注意：底部导航在 Router 上下文内的 `RootLayout` 中渲染（router/index.tsx），
 * 作为 Shell 的后代挂载，以保证 `useLocation` 可用 & `fixed` 相对 Shell 定位。
 */
export default function MobileAppShell({ children }: { children: ReactNode }) {
  return (
    <div className="bg-home-ambient relative flex h-full w-full max-w-[430px] flex-col overflow-hidden shadow-2xl transform-gpu standalone:h-screen">
      <div
        className="scrollbar-none min-h-0 flex-1 overflow-x-hidden overflow-y-auto"
        id="scroll-container"
      >
        {children}
      </div>
    </div>
  )
}
